import React from "react"
import Spinner from "components/Spinner"
import CheckMark from "components/Forms/Button/CheckMark"

export interface ButtonIconProps {
  loading?: boolean
  addCheckMark?: boolean
  icon?: React.ComponentType<{
    className?: string
  }>
  secondary?: boolean
  disabled?: boolean
}

const ButtonIcon = ({
  loading,
  addCheckMark,
  icon: Icon,
  secondary,
  disabled
}: ButtonIconProps) => {
  const checkmarkHoverStyles = secondary
    ? `group-hover:border-white`
    : `group-hover:border-black`

  if (loading) {
    return (
      <Spinner
        width={20}
        height={20}
        color={secondary ? `#000` : `#fff`}
        strokeWidth={15}
      />
    )
  }

  if (addCheckMark) {
    return (
      <CheckMark
        className={!disabled ? checkmarkHoverStyles : ``}
        color={secondary ? `#000` : `#fff`}
        data-testid="checkmark"
      />
    )
  }

  return Icon ? <Icon className="mr-2 w-4" /> : null
}

export default ButtonIcon
